// Comportamientos de interfaz sin React: cuenta regresiva, header sobre el hero, barra móvil del evento,
// compartir y el tiempo de apartado en el pago. Todo se vuelve a montar en cada turbo:load.

let cleanups = [];

const pad = (value) => String(value).padStart(2, '0');

// <div data-countdown="ISO"> con cuatro [data-countdown-unit] (días, horas, min, seg).
const mountCountdowns = () => {
  document.querySelectorAll('[data-countdown]').forEach((node) => {
    const target = new Date(node.dataset.countdown).getTime();
    const units = node.querySelectorAll('[data-countdown-unit]');

    const tick = () => {
      const left = Math.max(0, Math.floor((target - Date.now()) / 1000));
      if (left === 0) {
        node.hidden = true;
        return false;
      }
      const values = [Math.floor(left / 86400), Math.floor((left % 86400) / 3600), Math.floor((left % 3600) / 60), left % 60];
      units.forEach((unit, i) => { unit.textContent = pad(values[i]); });
      return true;
    };

    if (!tick()) return;
    const timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 1000);
    cleanups.push(() => clearInterval(timer));
  });
};

// En el home el header es transparente sobre el hero hasta que se hace scroll.
const mountHeader = () => {
  const header = document.querySelector('[data-site-header]');
  if (!header || !document.body.classList.contains('--overlay-header')) return;

  const onScroll = () => header.classList.toggle('--scrolled', window.scrollY > 24);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
  cleanups.push(() => window.removeEventListener('scroll', onScroll));
};

// Barra inferior del evento: aparece cuando el hero (y su botón de compra) sale de la pantalla.
const mountEventBar = () => {
  const bar = document.querySelector('[data-mobile-bar]');
  const hero = document.querySelector('[data-hero]');
  if (!bar || !hero || !('IntersectionObserver' in window)) {
    bar?.classList.remove('--hidden');
    return;
  }

  const observer = new IntersectionObserver(([entry]) => {
    bar.classList.toggle('--hidden', entry.isIntersecting);
  }, { threshold: 0 });
  observer.observe(hero);
  cleanups.push(() => observer.disconnect());
};

// Compartir con la hoja nativa del teléfono; en escritorio copia la liga.
const mountShare = () => {
  document.querySelectorAll('[data-share]').forEach((button) => {
    const label = button.querySelector('[data-share-label]');
    const onClick = async () => {
      const data = { title: button.dataset.shareTitle, url: button.dataset.shareUrl };
      try {
        if (navigator.share) {
          await navigator.share(data);
        } else {
          await navigator.clipboard.writeText(data.url);
          if (label) {
            label.textContent = '¡Liga copiada!';
            setTimeout(() => { label.textContent = 'Compartir'; }, 2000);
          }
        }
      } catch (_error) {
        // El usuario canceló o el navegador no dio permiso; no hay nada que hacer.
      }
    };
    button.addEventListener('click', onClick);
    cleanups.push(() => button.removeEventListener('click', onClick));
  });
};

// Tiempo que queda del apartado en la página de pago.
const mountHoldTimer = () => {
  const node = document.querySelector('[data-hold-timer]');
  if (!node) return;

  const target = new Date(node.dataset.holdTimer).getTime();
  const text = node.querySelector('[data-hold-text]');

  const tick = () => {
    const left = Math.max(0, Math.floor((target - Date.now()) / 1000));
    if (left === 0) {
      node.classList.add('--expired');
      text.textContent = 'El tiempo para pagar terminó. Recarga la página para volver a elegir tus boletos.';
      return false;
    }
    text.innerHTML = `Tus boletos están apartados <strong>${Math.floor(left / 60)}:${pad(left % 60)}</strong> min más.`;
    return true;
  };

  if (!tick()) return;
  const timer = setInterval(() => { if (!tick()) clearInterval(timer); }, 1000);
  cleanups.push(() => clearInterval(timer));
};

const mountUi = () => {
  cleanups.forEach((cleanup) => cleanup());
  cleanups = [];
  mountCountdowns();
  mountHeader();
  mountEventBar();
  mountShare();
  mountHoldTimer();
};

document.addEventListener('turbo:load', mountUi);
